

export class FilterOption {
    Id: number;
    Name: string;

    constructor(id: number, name: string) { this.Id = id; this.Name = name; }
}

export interface IFilter {
    triggerFilter(): void;
}